module.exports = __webpack_public_path__ + "img/Multiview - Gray - Selected.6b9bf167.png";